// A20 — THE LOCAL TODAY STRING. Brief 65 (brief 50 §4), the fifteenth of the sixteen.
//
//   src/views/CaseView.tsx:5616-5619@8fdbbd6c x src/views/CollectiveCaseView.tsx:2642-2645@8fdbbd6c  100.0%
//
// IDENTICAL modulo the name of the constant it was assigned to (`todayStrCa` /
// `todayStrCc`). Four lines, and worth its own row for what it is rather than
// its size: today in the BROWSER'S OWN zone, as yyyy-MM-dd.
//
// It is deliberately not `toISOString().slice(0, 10)`, which is UTC and is a
// day out for a European evening — the difference this file exists to keep. Any
// later reader tempted to shorten it should read that sentence twice.
export const localTodayStr = () => localDayStr(new Date());

// 207B §3 — the same string for ANY moment: the day it falls on in the
// browser's own zone (a chat message sent at 00:30 in Brussels is that day's,
// where `toISOString().slice(0, 10)` files it under the day before).
export const localDayStr = (t: Date) =>
  `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, "0")}-${String(t.getDate()).padStart(2, "0")}`;
